jQuery.fn.extend({
	modal: function (options = {}) {
		return this.each(function () {
			var
				$lastFocus = document.activeElement,
				$modal = $(this),
				$button = $($modal.data('button') || options.button),
				$wrapper = $($modal.data('wrapper') || options.wrapper || '#wrapper');

			function preventKeydownOutsideOfModal (event) {
				var $focusable = $modal.add($(':focusable', $modal));

				if ('Tab' === event.key &&
				    $(event.target).is($focusable.last()) ||
						!(jQuery.contains($modal.get(0), event.target) || $modal.is(event.target))) {
					event.preventDefault();
					$focusable.first().focus();
				}
			}

			function open() {
				$lastFocus = document.activeElement;

				$(document).on('keydown', preventKeydownOutsideOfModal);

				$modal
					.trigger('modal:show')
					.attr('aria-hidden', false)
					.attr('tabindex', '0')
					.addClass('in');

				$button.attr('aria-expanded', true);

				$wrapper.addClass('modal-open');

				//document.body.scrollTop = document.documentElement.scrollTop = 0;

				$modal
					.focus()
					.trigger('modal:shown');
			}

			function close() {
				$(document).off('keydown', preventKeydownOutsideOfModal);

				$modal
					.trigger('modal:hide')
					.attr('aria-hidden', true)
					.removeAttr('tabindex')
					.removeClass('in');

				$button.attr('aria-expanded', false);

				$wrapper.removeClass('modal-open');

				$lastFocus.focus();

				$modal.trigger('modal:hidden');
			}

			function swap() {
				$(document).off('keydown', preventKeydownOutsideOfModal);

				$modal
					.trigger('modal:hide')
					.attr('aria-hidden', true)
					.removeAttr('tabindex')
					.removeClass('in');

				$button.attr('aria-expanded', false);

				$modal.trigger('modal:hidden');
			}

			$modal
				.attr('aria-labelledby', $button.attr('id'));

			$button
				.attr('aria-controls', $modal.attr('id'))
				.on('click', open);

			$wrapper
				.prepend(
					$modal
						.on('modal:open', open)
						.on('modal:close', close)
						.on('modal:swap', swap)
						.on('click', '.close', close)
				);
		});
	}
});



// WEBPACK FOOTER //
// ./assets/js/components/extensions/jquery.modal.js